export default {
  head: {
    index: "Home",
    application: "Ecosystem",
    about: "About Lambda",
    doc: "Docs",
    tech: "Technology",
    ggl: "Announcement",
    gg: "Announcement",
    news: "News",
    activity: "Latest Activities",
    project: "Weekly Project Report",
    help: "Help center",
    aboutus: "About us",
    wallet: "Wallet",
    explorer: "Explorer",
    evmexplorer: "EVM Explorer",
    blockexplorer: "Block Explorer",
    dataexplorer: "Data Explorer",
    validators: "Validators",
    providers: "Providers",
    docs: "Docs",
    dis: "Discovery",
    storage: "Storage",
    legacy: "Lambda Legacy",
    deprecated: "(Deprecated)",
    launchapp: "Get LAMBDA"
  },
  home: {
    s1: {
      t1: "Return Data Ownership to Users",
      t2: "A leading Web3 infrastructure network",
      t3: "Revolutionary changes are underway",
      t4: 'Decentralized Storage 3.0 Evolution ',
      t5: 'LWS Modular Storage Network',
      t6: 'data availability layer and on-chain NFT storage',
      mt: 'Lambda Network is a fast advanced and scalable Web 3 infrastructure provides data availability layer and on-chain NFT storage',
      t7: 'A Web3 infrastructure aims to provide permanent storage capabilities for all blockchain.',
      b1: "Mainnet Officially Launched",
      b2: 'Get LAMBDA',
      b3:'Build Now',
      announce: {
        t1: "Announcement-Lambda 3rd Round Storage Mining Test Launched",
        t2: "Announcement-Lambda's New Brand Image",
        t3: "Lambda Developer Reward Program",
        t4: "Lambda Status & Statistics System Officially Released",
        t5: "Roadmap｜Lambda 2020 Review of Annual Program and Events",
        t6: "Lambda Storage Mining  Launched",

        tt1: "Lambda Web3 Service: How it works?",
        tt2: "Genify, the first Generative NFT brand in Lambda ecosystem has officially launched!",
        tt3: "LAMB-Wallet-Chrome Installation Guide",
        tt4: "LambSwap Mining Tutorial",
        tt5: "Lambda FAQ",
        tt6: "The Lambda Network introducing “The Renaissance” Version update",
        tt7:
          "Lambda Network will launch the first NFT Marketplace in the Cosmos ecosystem",
        tt8: "Notes on Lambda Network upgrade and asset migration"
      }
    },
    s2: {
      t1:
        "Lambda Network is a fast, advanced and scalable Web 3 infrastructure provides data availability layer and on-chain NFT storage.",
      t2: "The future of Cloud Storage",
      t3:'Build on any blockchain with Lambda',
      stake: {
        apytext: 'TYPICAL APY',
        rewardstitle: 'Staking LAMBDA to earn rewards',
        rewardstext: 'When staking is complete, rewards will start to be calculated immediately. At any time, stakers can claim their cumulative reward through dApp.',
        ifstake: 'IF YOU STAKE',
        COMMISSION: 'COMMISSION',
        validators: '(Varies between validators)',
        yourrewards: 'YOUR REWARDS',
        stakingbtn:'Staking LAMBDA'
      },
      panel: {
        p1: {
          t: "Data Confirmation Right on-Chain",
          l1: "Innovation public chain with high performance",
          l2:
            "Complete on-chain verification of off-chain data by using Proof of Space Time",
          l3: "Proof of Retrievability technology"
        },
        p2: {
          t: "Protect user's data privacy",
          l1:
            "Multi-authority attribute based on encrypted(MA-ABE) access control",
          l2: "Defined data sharing access granularity",
          l3:
            "GDPR practitioners and infrastructure for data privacy protection"
        },
        p3: {
          t: "Return Data Ownership to Users",
          l1: "Data right is protected by the user's private key",
          l2: "Complete data transactions on market place on the chain",
          l3: "Data value is divisible and measurable"
        }
      }
    },
    s3: {
      h1: "The Overview of Lambda Storage Network",
      h2: " Empowering the Next Generation of Value Internet",
      number: "",
      t1: "Validators",
      t2: "Miners",
      t3: "Mainnet Accounts",
      btn: "Explorer",
      t4: "Network Capacity"
    },
    s4: {
      t1: "Lambda is an Open Blockchain Network,",
      t2:
        "Anyone can join in the Lambda blockchain network, for keeping abreast of the new development",
      t3: "Anyone can join in the Lambda blockchain network,",
      t4: " for keeping abreast of the new development"
    },
    s5: {
      t1: "Download",
      t2: "Join Lambda Consensus Network, A Click to Deploy as Validator",
      t3: "Join Lambda Consensus Network，",
      t4: "A Click to Deploy as Validator",
      btn: "Experience now",
      p1: {
        t1: "Lambda Economic White Paper",
        t2:
          "Including Lambda public chain's architecture design principles and token model, which helps you quickly understand the design concept of Lambda dual tokens model",
        btn: "Download"
      },
      p2: {
        t1: "LAMB Wallet",
        t2:
          "LAMB Wallet contains the full ecological function of the mainnet,digital asset management, proposal voting, consensus network pledge, and storage space purchase.",
        btn: "Download APP"
      },
      p3: {
        t1: "Lambda Mainnet Tutorials",
        t2:
          "Learn more about the entire flow of accessing Lambda decentralized storage network - Validator access, run consensus network, and provide storage space.",
        btn: "View the Tutorial"
      },
      p4: {
        t1: "Download Validator and Miner program",
        t2:
          "Contains the latest version of Lambda's Validator program and Miner program",
        btn: "Download"
      }
    },
    s6: {
      t1: "Lambda Milestones",
      list: {
        l1: "Launched Lambda project ",
        l2: "Released Whitepaper",
        l3: "Received 20,000,000 USDT fund raising",
        l4: "Released PoST Algorithm",
        l5: "Released Open source core code",
        l6: "Launched Lambda testnet",
        l7: "Launched Lambda mainnet consensus network",
        l8: "Teasted Lambda mainnet storage function",
        l9: "Launched Lambda mainnet storage function",
        l10: "Development of derivative technology ecological projects",
        l11: "NFT technology development",
        l12: "EVM integration",
        l13: "NFT platform test",
        l14: "Renaissance testnet launch",
        l15: "NFT platform release",
        l16: "The 1st Multichain GenArt Platform Genify Launched",
        l17: "Spark Upgrade",
        l18: "Lambda Modular Storage Launched",
        l19: "Genify Became the 3rd biggest GenArt Platform",
        l20: "Genify Joined Bitcoin Ecosysterm",
        l21: "The Permanent DA Solution Lambda DA"
      }
    },
    s7: {
      eco: {
        t1: "Future-oriented LambdaEco",
        t2: "Data value driven, the great future-oriented construction",
        btn: "Learn more",
        t3: "Lambda Ecological Foundation",
        t4:
          "An ecological foundation for businesses and developers, designed to empower a new generation of digital economy",
        t5: "Wallet",
        t6: "Research Project",
        t7: "Enterprise solutions"
      },
      tech: {
        t1: "Lambda Research Program",
        t2:
          "Lambda research program is a laboratory for new technologies to promote the combination of industry, university and research. Lambda Foundation will be dedicated to bring top universities, research institutions and top talents together to conduct theoretical research and technological exploration in the field of blockchain storage"
      },

      notice: {
        title: "Announcement",
        t1: "Notes on Lambda Network upgrade and asset migration",
        t2: "Lambda Network will launch On-Chain NFT Marketplace",
        t3: "The Lambda Network introducing “The Renaissance” Version update",
        btn: "Learn more"
      },
      news: {}
    },
    s8: {
      title: "DAPP based on LambdaNetwork",
      desc: "The first innovative, open, creator-friendly, generative art platform where users from any blockchain ecosystem can create and collect generative art.",
      desc2: "Be the first to discover some epic Web3 content.Never miss out on any opportunities, events, knowledges, and news."
    },
    s9: {
      title: "Ecosystem",
      desc: "Affine.ART is a Web3 NFT Platform Showcasing Exclusive 1/1 Digital Masterpieces."
    }
  },
  about: {
    t1:
      "The New Generation Public Chain with Decentralized Data Storage Technology",
    t2: "The Cornerstone of Digital Economy Development and Innovation",
    i1:
      "Lambda provides a secure, reliable, and infinitely scalable decentralized storage network through P2P network and innovative PoST (Proof of Space-Time). To realize the safe, high-speed, and reliable operation of decentralized storage of data, data confirmation right on-chain, data storage transactions, and data security verification on the Lambda Chain consensus network.",
    btn: "Click for more details，Lambda FAQ",
    s1: {
      h3: "Consensus Network and Mechanism",
      t1: "LBFT Consensus Protocol",
      t2: "Double Token Economic Model",
      t3: "New on-Chain Governance",
      t4: "Two-Layer Incentive Mechanism"
    },
    s2: {
      h3: "Storage Network and Features",
      t1: "LPDP Storage Proof",
      t2: "Decentralized Storage Transactions",
      t3: "Data Encryption and Dispersion",
      t4: "Data Retrieval Consensus"
    }
  },
  doc: {
    t1: "Maximize Fund Utilization",
    t2: "It's time to start mining",
    dailyOutput: "Daily Output",
    totalCapacity: "System Storage Space",
    totalPower: "System Hashrate",
    about: "≈",
    btn1: "Mining Tutorial",
    btn2: "Community",
    btn3: "Download Program",
    farmingLand: "Farming Land",
    titleH1:
      "Benefited by ALM Protocol, token holders make deposit and distribute mining returns, miners enjoy mining without staking.",
    reserve: "Total Deposit",
    reserveIncome: "Daily deposit returns",
    reserveConvert: "≈",
    provide1: "*Estimated daily returns for depositing",
    provide2: " reserve.",
    provide3: "Deposit mLAMB",
    totalComputingPower: "Total Hashrate",
    computingPower: "Hashrate Returns",
    computingPower1: "Supply Hashrate",
    Mining: "Mining",
    Mining1: "*For miners, Deposit ",
    Mining2: "for reserve to mine.",
    Mining3: "Become a miner",
    Mining4:
      "Miners make deposit and supply hashrate to enjoy massive hashrate returns.",
    works: "How mLAMB works？",
    works1: "mLAMB is a mining certificate of Lambda Network.",
    works2: "Miners can exchange mLAMB with LAMB token to mine.",
    works3:
      "mLAMB produced by mining can be traded to LAMB through cross-chain trading.",
    works4: "Exchange on LambSwap",

    h3: "It can be achieved with the support of Lambda's underlying technology",
    l1: "Related Links",
    btn: {
      b1: "Explorer",
      b2: "Status & Statistics",
      b3: "Lambda S3"
    },
    s1: {
      h4: "Blockchain Application",
      s1: {
        t1: "Dapp, Games",
        t2: "Content，Education，Social，Blockchain Gaming"
      },
      s2: {
        t1: "Digital Asset Management",
        t2: "Wallet, Staking"
      },
      s3: {
        t1: "Tools Products",
        t2: "Blockchain Explorer"
      },
      s4: {
        t1: "Decentralized Storage Application",
        t2: "Hard Drive, File Transfer Tools"
      }
    },
    s2: {
      h4: "Data Security Solutions",
      t1: "Data Privacy Protection Solutions",
      t2: "Dapp, Games",
      t3: "Data backup and Disaster recovery",
      t4: "Medical Data"
    },
    s3: {
      t1: "Lambda Technical Forum",
      t2: "Join the forum, talk and share your idea, mining experience, etc",
      btn: "Join Us"
    },
    s4: {
      s1: {
        h5: "User guide",
        t1: "Lambda Wallet Instruction",
        t2: "Lambda Farming Hub Protocol",
        t3: "Lambda Farming Hub Market"
      },
      s2: {
        h5: "Principle Introduction",
        t1: "Lambda Technical Architecture",
        t2: "The overview of LPDP"
      },
      s3: {
        t1: "Lambda Wallet API",
        t2: "S3 Gateway API"
      }
    }
  },
  eco: {
    t1: "Future-oriented LambdaEco",
    t2: "Data value driven, the great future-oriented construction",
    s1: {
      t1:
        "Decentralized storage technology enthusiasts can join Lambda DAO, where you can become a Validator, Storage miner, etc.",
      btn: "Learn More"
    },
    s2: {
      h3: "Lambda Ecological Foundation",
      h4:
        "An ecological foundation for businesses and developers, designed to empower a new generation of digital economy",
      s1: {
        t1: "Digital economy, FinTech",
        t2: "Wallets, Economic Models, Digital Assets"
      },
      s2: {
        t1: "Application Ecosystem based on decentralized Storage",
        t2: "Distributed Hard Drive, File Transfer Tool, Content Platform"
      },
      s3: {
        t1: "Enterprise Solutions",
        t2:
          "Support supervise private chain deployment, enterprise alliance storage, data asset transactions"
      },
      s4: {
        t1: "Storage Miner Ecosystem",
        t2:
          "High-reliability storage technology solution, Large-scale mining pool operation system, Data migration and recovery"
      },
      btn: "Join Us"
    }
  },
  tech: {
    t1: "Technology vision",
    t2: "Decentralized storage technology drives the new era of the Internet",
    h4:
      "Lambda Foundation and R & D team are committed to promote scientific research innovation of blockchain and decentralized storage",
    s1: {
      h1: "Achievements",
      t1: "Lambda Economic White Paper",
      t2: "Lambda White Paper",
      t3: "Lambda Technology Architecture",
      btn1: "Download",
      btn2: "View"
    },
    s2: {
      t1: "R&D Team",
      t2:
        "Lambda R & D team is composed of computer science experts, university researchers and engineers from China and the United States, which has established cooperation with many well-known scientific research enterprises."
    },
    s3: {
      t1: "Lambda Spark Project",
      t2:
        "The Lambda Spark Program is supported by the Lambda Ecological Foundation. It is engaged in cutting-edge science and technology exchanges and academic discussions among well-known universities around the world. It is a non-profit project dedicated to promoting the cultivation of talents in the fields of blockchain science, cryptography, computer science, distributed storage technology, etc., and exporting and balancing educational resources",
      t3:
        "Lambda Spark Project has established scientific research cooperation with many well-known enterprise universities"
    },
    s4: {
      t1: "Lambda Spark Program Academic Foundation",
      t2:
        "The Lambda Spark Program Academic Foundation is supported by the Lambda Ecological Foundation, which is used to reward research achievements that have made significant contributions to the development of decentralized storage technology research",
      t3:
        "University institutions cooperation, please send application email to：star@lambdastorage.com"
    }
  },
  dao: {
    t1: "Lambda Ecosystem's Role",
    s1: {
      t1: "Validator",
      t2:
        "Individuals and institutions can participate as validators and participate in the consensus network to become consensus validator on the Lambda mainnet",
      btn: "Apply to be a Lambda Validator"
    },
    s2: {
      t1: "Storage Miner",
      t2:
        "Provide storage space for Lambda decentralized storage network, responsible for storage system maintenance and construction, and participate in storage market transactions",
      btn: "Apply to be a Lambda Storage Miner"
    },
    s3: {
      t1: "Storage Market Maker",
      t2:
        "In the context of enterprise-level resource allocation, storage asset market makers will greatly improve the efficiency of the supply chain in distributed business. Large-scale centralized storage supplier storage resources, integrating resources to provide stable intermediary services for storage demand parties (applications)",

      t3:
        "Lambda storage asset market makers now target IT industry-wide business organizations",
      i1: "Enterprise Application",
      i2: "User-oriented Application Value-Added Service Providers",
      i3: "Selling Agent",
      i4: "etc.",
      btn: "Apply to be a storage market maker"
    },
    s4: {
      t1: "Lambda Technical Group",
      t2:
        "Individuals and institutions can participate as Validators and participate in the consensus network to become consensus validator on the Lambda mainnet",
      btn: "Join Us"
    },
    s5: {
      t1: "Developer",
      t2:
        "Provide storage space for Lambda decentralized storage network, responsible for storage system maintenance and construction, and participate in storage market transactions",
      btn: "Developer Center"
    }
  },
  news: {
    t1: "Announcements",
    t2: "Summarizes all official announcements from Lambda",
    s1: {
      h1: "Latest News",

      t1: "Announcement-Lambda storage mining tests phase 3 launched",

      t2:
        "The Lambda storage function has passed two rounds of testing and met the test expectations. In the first two phase, a large number of tests have been conducted on Validator, miner-side storage management, storage business processes, and mining pool architecture support, and a large number of technologies have been obtained breakthrough, multi-versioned refactoring of storage code and introduction of new technologies. Next we will start the third round of testing, which is also the last round of testing in the Lambda storage section.",

      btn: "Click for details"
    }
  },
  team: {
    t1: "The background of Lambda team",

    t2:
      "Our commission is to promote computer science and technology, for building a new infrastructure for the next generation of Internet.",

    p1:
      "Decentralized storage is disrupting new areas of blockchain technology. As the first comer in this field in the blockchain industry, Lambda team is assisted the development of decentralized storage technology. Lambda’s mission is to promote decentralization of the Internet, with the goal of creating a truly, safe and open a data storage infrastructure for the next generation of blockchain. Data storage alter as assets, and to build a truly value of Internet by data value driven. ",

    p2:
      "The founder of Lambda, He Xiaoyang, known as “the first person in China’s APM industry”, was selected as the “35 Under 35” list of entrepreneurs in 2015. The OneAPM founded by He Xiaoyang has won the “China’s Best APM Company of the Year” and has been successfully listed on the New Third Board in 2016.",

    p3:
      "Lambda has received the invest funding from over 23 well-known VC investment institutional include BitMan、FBG、Zhenge Fund、Dfund、Funcity Capital、CEYUAN digital capital、BlockVC、INBlockChain、Timestamp Capital、NGC、DATA、Genesis capital、One Boat capital、Bitcoin World、Redbank capital、Viking Capital、H.Capital、Reflextion Capital、KOSMOS、Bluehill and we have established a strategy corporation with Perlin、IOST、Ankr、DATA、Bitcv, etc."
  },

  download: {
    t1: "Lambda Wallet",
    t2:
      "Lambda Wallet includes mainstream wallet products that support LAMB mainnet assets and functions for managing your LAMB digital assets at all times",

    s1: {
      h3: "Terms of Use",
      p1: "Be sure to know before you choose to use the LAMB wallet",
      p2:
        "LAMB wallets are generated by contributions from LAMB community developers, and are only displayed on Lambda's official website as recommended.",

      p3:
        "Please note that you are responsible for choosing your LAMB wallet carefully and protect your LAMB mainnet assets",

      p4:
        "If the developer independently develops the Lambda block explorer or wallet, you can contact the email：feedback@Lambdastorage.com, Lambda team will recommend and exposure according to the situation."
    },
    s2: {
      t1: "Lambda Wallet",
      b1: "MAC",
      b2: "Windows",
      b3: "Android IOS",
      b4: "Chrome Extensions",
      b5: "Chrome plug in installation guide"
    }
  },
  join: {
    h3: "Community Hub Join our global community",
    p1: "Country and Region",
    p2: "City",
    p3: "Community Members"
  },
  media: {
    title: "Latest News",
    t1: "Genify, the first Generative NFT brand in Lambda ecosystem has officially launched",
    t2: "The Lambda Spark Upgrade: Empower Web3 with Better Storage",
    t3: "LNS, the First Web3 Generated Art Domain Service Launched",
    t4: 'Lambda Web3 Service: How it works?',
    t5: "Decentralized storage network Lambda and Conflux reach strategic cooperation to jointly develop Web3 infrastructure and NFT field",
    t6: "Lambda Data Availability (LDA) Technical Solution Design"
  },
  application: {
    title1: "Lambda DAPP Ecosystem",
    title2: "DeFi Decentralized Storage Data Exchange DAPP",
    btn: "DEX",
    content1: "Distributed Storage Digital Assets Exchange",
    content2: "Interconnect Decentralized Storage and Defi",
    content3: "AMM Automated Market Maker",
    content4: "Airdrop Bonus"
  },
  404: {
    t1: "The page you visited is missing…",
    t2: "It will jump to home page in",
    t3: "s"
  },
  link: {
    index1: {
      l1:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360007007138-Meeting-Review-Lambda-s-Third-Phase-Storage-Mining-Test",
      l2:
        "https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006520818-Lambda-%E5%85%A8%E6%96%B0%E5%93%81%E7%89%8C%E5%BD%A2%E8%B1%A1%E5%8F%91%E5%B8%83",
      l3: "https://www.lambdastorage.com/doc/Lambda-Economic-Whitepaper.pdf",
      l4:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/7834271109393-Notes-on-Lambda-Network-upgrade-and-asset-migration",
      l5:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/7831671395601-Lambda-Network-will-launch-On-Chain-NFT-Marketplace-",
      l6:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/7831456732049-The-Lambda-Network-introducing-The-Renaissance-Version-update",
      l7:
        "https://lambdastorage.zendesk.com/hc/en-001/sections/360001762958-Lambda-Latest-News",
      l8:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360007660258-Lambda-Developer-Reward-Program",
      l9:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360008638337-Lambda-Status-Statistics-System-Officially-Released-",
      l10:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360010208898-Roadmap-Lambda-Milestone-2020",
      firstLink: "https://www.lambswap.fi/#/exchange",
      ll1:
        "https://lambdanetwork.medium.com/lambda-web3-service-how-it-works-1d68e25d83b5",
      ll2:
        "https://lambdanetwork.medium.com/genify-the-first-generative-nft-brand-in-of-lambda-ecosystem-has-officially-launched-9954e8fd05d1",
      ll3:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360017155758-LAMB-Wallet-Chrome-Installation-Guide",
      ll4:
        "https://lamb-swap.gitbook.io/lambswap/v/jian-ti-zhong-wen/lambswap-tutorial/join-liquidity-mining",
      ll5:
        "https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006363057-Lambda-FAQ",
      ll6:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/7831456732049-The-Lambda-Network-introducing-The-Renaissance-Version-update",
      ll7:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/7831671395601-Lambda-Network-will-launch-the-first-NFT-Marketplace-in-the-Cosmos-ecosystem",
      ll8:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/7834271109393-Notes-on-Lambda-Network-upgrade-and-asset-migration"
    },
    head1: {
      l1:
        "https://lambdastorage.zendesk.com/hc/en-001/sections/360001762958-Lambda-Latest-News",
      l2:
        "https://lambdastorage.zendesk.com/hc/en-001/sections/360001762958-Lambda-Latest-News",
      latest:
        "https://lambdastorage.zendesk.com/hc/en-001/sections/360001762958-Lambda-Latest-News",
      project:
        "https://lambdastorage.zendesk.com/hc/en-001/sections/360001765978-Lambda-Weekly-Report",
      help: "https://lambdastorage.zendesk.com/hc/en-001"
    },
    about1: {
      l1:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360006363057-Lambda-FAQ-"
    },
    doc1: {
      l1:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360006363117-Lambda-Technical-Group"
    },
    eco1: {
      l1:
        "https://lambdastorage.zendesk.com/hc/en-001/articles/360006398977-Contact-US-"
    },
    tech1: {
      l1: "https://www.lambdastorage.com/doc/Lambda-Economic-Whitepaper.pdf",
      l2: "https://www.lambdastorage.com/doc/Lambda-WhitePaper-En.pdf",
      l3:
        "https://www.lambdastorage.com/doc/Lambda-Technical-Architecture-en.pdf",
      l4: "https://www.lambdastorage.com/doc/LPDP.pdf"
    }
  },
  docs: {
    t1: "The guide for Chrome plug-in wallet installation",
    a1: "Download Chrome Plug-in Wallet",
    a2: "Unpacked the downloaded package",
    a3:
      "Download Google Chrome browser (https://www.google.cn/chrome/) and install it.",
    a4: "Open Google Chrome and click “Extensions” in the top right corner",
    a5: "Click “Manage Extensions”",
    a6: "Click on the top right corner to open Developer mode.",
    a7:
      'Click "Load unpacked", select the previously unpacked Chrome plug-in wallet, and start using it after successful addition.',
    a8:
      "We can use Chrome plug-in wallet by clicking the Chrome plug-in wallet button in the upper right corner or find it in the “Extensions”.",
    a9: "Warning",
    a10:
      "Lambda Wallet is a decentralized wallet. All the user's information is stored in the user's browser and kept by the user, not in the Lambda wallet database. Users whose wallets have been downloaded successfully (including the Lambda mainnet wallet) , to avoid assets loss, please make sure to back up your mnemonic phrase. If you don’t back up your mnemonic phrase, we can not help you to retrieve your assets. ",
    a11: "../../public/docs/en1.png",
    a12: "https://images-cdn.shimo.im/hxhYXeddaCL1APUL__thumbnail.png",
    a13: "https://images-cdn.shimo.im/QpgiKE1rCFZzKz0Q__thumbnail.png",
    a14: "https://images-cdn.shimo.im/cdhX92DIgKbH4vZG__thumbnail.png",
    a15: "https://images-cdn.shimo.im/2bpzNWys1v4vW5B6__thumbnail.png"
  }
};
